export const Icon = ({ type, size = "5", className = "", color }) => {
  className += " inline-block";
  const sizeCss = "w-" + size + " h-" + size;
  switch (type) {
    case "text-doc":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
          />
        </svg>
      );
    case "link":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
          />
        </svg>
      );
    case "save":
      return (
        <svg
          className={sizeCss + " " + className}
          fill="#000000"
          height="200px"
          width="200px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 64 64"
          enable-background="new 0 0 64 64"
          xmlSpace="preserve"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="2"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g id="Floppy-disk">
              <path d="M35.2673988,6.0411h-7.9999981v10h7.9999981V6.0411z M33.3697014,14.1434002h-4.2046013V7.9387999h4.2046013V14.1434002z"></path>
              <path d="M41,47.0410995H21c-0.5527992,0-1,0.4472008-1,1c0,0.5527,0.4472008,1,1,1h20c0.5527,0,1-0.4473,1-1 C42,47.4883003,41.5527,47.0410995,41,47.0410995z"></path>
              <path d="M41,39.0410995H21c-0.5527992,0-1,0.4472008-1,1c0,0.5527,0.4472008,1,1,1h20c0.5527,0,1-0.4473,1-1 C42,39.4883003,41.5527,39.0410995,41,39.0410995z"></path>
              <path d="M12,56.0410995h38v-26H12V56.0410995z M14,32.0410995h34v22H14V32.0410995z"></path>
              <path d="M49.3811989,0.0411L49.3610992,0H7C4.7908001,0,3,1.7909,3,4v56c0,2.2092018,1.7908001,4,4,4h50 c2.2090988,0,4-1.7907982,4-4V11.6962996L49.3811989,0.0411z M39.9604988,2.0804999v17.9211006H14.0394001V2.0804999H39.9604988z M59,60c0,1.1027985-0.8972015,2-2,2H7c-1.1027999,0-2-0.8972015-2-2V4c0-1.1027999,0.8972001-2,2-2h5v20.0410995h30V2h6.5099983 L59,12.5228996V60z"></path>
            </g>{" "}
          </g>
        </svg>
      );
    case "comments":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 01-.923 1.785A5.969 5.969 0 006 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337z"
          />
        </svg>
      );
    case "arrow-up-circle":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
    case "envelope":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
          />
        </svg>
      );
    case "loading-dots":
      return (
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 80 20"
          className={sizeCss + " " + className}
        >
          <circle cx="10" cy="10" r="10" fill="#666">
            <animate
              attributeName="cx"
              from="10"
              to="40"
              dur="0.5s"
              calcMode="spline"
              keySplines="0.42 0 0.58 1"
              keyTimes="0;1"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="10" cy="10" r="0" fill="#555">
            <animate
              attributeName="r"
              from="0"
              to="10"
              dur="0.5s"
              calcMode="spline"
              keySplines="0.42 0 0.58 1"
              keyTimes="0;1"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="40" cy="10" r="10" fill="#777">
            <animate
              attributeName="cx"
              from="40"
              to="70"
              dur="0.5s"
              calcMode="spline"
              keySplines="0.42 0 0.58 1"
              keyTimes="0;1"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="70" cy="10" r="10" fill="#666">
            <animate
              attributeName="r"
              from="10"
              to="0"
              dur="0.5s"
              calcMode="spline"
              keySplines="0.42 0 0.58 1"
              keyTimes="0;1"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      );
    case "user":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            fillRule="evenodd"
            d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
            clip-rule="evenodd"
          />
        </svg>
      );
    case "phone":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            fillRule="evenodd"
            d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
            clip-rule="evenodd"
          />
        </svg>
      );
    case "eye":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      );
    case "copy":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
          />
        </svg>
      );
    case "user-group":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className={`${sizeCss} ${className}`}
        >
          <path
            fillRule="evenodd"
            d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z"
            clip-rule="evenodd"
          />
          <path d="M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z" />
        </svg>
      );
      break;
    case "arrow-left-on-rectangle":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={"animate-spin " + sizeCss + " " + className}
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
          />
        </svg>
      );
    case "inline-loader":
      return (
        <>
          <svg
            className={`inline ${
              color || "text-gray-500"
            } animate-spin dark:text-gray-600 fill-gray-200 ${sizeCss} ${className}`}
            aria-hidden="true"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </>
      );
    case "arrow-left":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          />
        </svg>
      );
      break;
    case "arrow-right":
    case "arrow_right":
      return (
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893L15.7071 6.29289C16.0976 6.68342 16.0976 7.31658 15.7071 7.70711L9.70711 13.7071C9.31658 14.0976 8.68342 14.0976 8.29289 13.7071C7.90237 13.3166 7.90237 12.6834 8.29289 12.2929L12.5858 8L1 8C0.447716 8 0 7.55229 0 7C0 6.44772 0.447716 6 1 6H12.5858L8.29289 1.70711C7.90237 1.31658 7.90237 0.683418 8.29289 0.292893Z"
            fill="#111827"
          />
        </svg>
      );
      break;
    case "check-circle":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
      break;
    case "bolt":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
          />
        </svg>
      );
      break;
    case "check":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 12.75l6 6 9-13.5"
          />
        </svg>
      );
      break;
    case "plus":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>
      );
      break;
    case "minus":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15" />
        </svg>
      );
      break;
    case "arrow-right2":
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          strokeWidth={1.5}
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path d="M 9 6 L 15 12 L 9 18" strokeWidth="2" />
        </svg>
      );
      break;
    case "arrow-down2":
      return (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          strokeWidth={1.5}
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path d="M18 9L12 15L6 9" strokeWidth="2" />
        </svg>
      );
      break;
    case "arrowDown":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
          />
        </svg>
      );
      break;
    case "arrowUp":
    case "arrow-up":
    case "arrow_up":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 15.75l7.5-7.5 7.5 7.5"
          />
        </svg>
      );
      break;
    case "filter":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
          />
        </svg>
      );
      break;
    case "edit":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
          />
        </svg>
      );
      break;
    case "remove":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
          />
        </svg>
      );
      break;
    case "elipses_v":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
          />
        </svg>
      );
      break;
    case "cross":
      return (
        <svg
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          className={sizeCss + " " + className}
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          ></path>
        </svg>
      );
      break;
    case "bars":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
          />
        </svg>
      );
      break;
    case "arrow_forward":
      return (
        <svg
          width="15"
          height="16"
          viewBox="0 0 17 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.025 20L0.25 18.225L8.475 10L0.25 1.775L2.025 0L12.025 10L2.025 20Z"
            fill="black"
            fillOpacity="0.6"
          />
        </svg>
      );
      break;
    case "arrow_down":
    case "arrow-down":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
          />
        </svg>
      );
      break;
    case "info":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className={sizeCss + " " + className}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
          />
        </svg>
      );
      break;
    case "tick_green":
      return (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M11.5 22.3C17.4646 22.3 22.3 17.4646 22.3 11.5C22.3 5.53528 17.4646 0.699951 11.5 0.699951C5.53528 0.699951 0.699951 5.53528 0.699951 11.5C0.699951 17.4646 5.53528 22.3 11.5 22.3ZM16.5045 9.75455C17.0318 9.22734 17.0318 8.37256 16.5045 7.84536C15.9773 7.31815 15.1226 7.31815 14.5954 7.84536L10.15 12.2908L8.40455 10.5454C7.87734 10.0181 7.02256 10.0181 6.49536 10.5454C5.96815 11.0726 5.96815 11.9273 6.49536 12.4545L9.19536 15.1545C9.72256 15.6818 10.5773 15.6818 11.1045 15.1545L16.5045 9.75455Z"
            fill="#3FC93C"
          />
        </svg>
      );
      break;
    case "tick_light_green":
      return (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M11.5 22.3C17.4646 22.3 22.3 17.4646 22.3 11.5C22.3 5.53528 17.4646 0.699951 11.5 0.699951C5.53528 0.699951 0.699951 5.53528 0.699951 11.5C0.699951 17.4646 5.53528 22.3 11.5 22.3ZM16.5045 9.75455C17.0318 9.22734 17.0318 8.37256 16.5045 7.84536C15.9773 7.31815 15.1226 7.31815 14.5954 7.84536L10.15 12.2908L8.40455 10.5454C7.87734 10.0181 7.02256 10.0181 6.49536 10.5454C5.96815 11.0726 5.96815 11.9273 6.49536 12.4545L9.19536 15.1545C9.72256 15.6818 10.5773 15.6818 11.1045 15.1545L16.5045 9.75455Z"
            fill="#B3D099"
          />
        </svg>
      );
      break;
    case "noti":
      return (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M22.3 11.5C22.3 17.4646 17.4646 22.3 11.5 22.3C5.53528 22.3 0.699951 17.4646 0.699951 11.5C0.699951 5.53528 5.53528 0.699951 11.5 0.699951C17.4646 0.699951 22.3 5.53528 22.3 11.5ZM12.85 16.9C12.85 17.6455 12.2455 18.25 11.5 18.25C10.7544 18.25 10.15 17.6455 10.15 16.9C10.15 16.1544 10.7544 15.55 11.5 15.55C12.2455 15.55 12.85 16.1544 12.85 16.9ZM11.5 4.74995C10.7544 4.74995 10.15 5.35437 10.15 6.09995V11.5C10.15 12.2455 10.7544 12.85 11.5 12.85C12.2455 12.85 12.85 12.2455 12.85 11.5V6.09995C12.85 5.35437 12.2455 4.74995 11.5 4.74995Z"
            fill="#C9B23C"
          />
        </svg>
      );
      break;
    case "noti_danger":
      return (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M22.3 11.5C22.3 17.4646 17.4646 22.3 11.5 22.3C5.53528 22.3 0.699951 17.4646 0.699951 11.5C0.699951 5.53528 5.53528 0.699951 11.5 0.699951C17.4646 0.699951 22.3 5.53528 22.3 11.5ZM12.85 16.9C12.85 17.6455 12.2455 18.25 11.5 18.25C10.7544 18.25 10.15 17.6455 10.15 16.9C10.15 16.1544 10.7544 15.55 11.5 15.55C12.2455 15.55 12.85 16.1544 12.85 16.9ZM11.5 4.74995C10.7544 4.74995 10.15 5.35437 10.15 6.09995V11.5C10.15 12.2455 10.7544 12.85 11.5 12.85C12.2455 12.85 12.85 12.2455 12.85 11.5V6.09995C12.85 5.35437 12.2455 4.74995 11.5 4.74995Z"
            fill="#C93C3C"
          />
        </svg>
      );
      break;
    case "noti_red":
      return (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M22.3 11.5C22.3 17.4646 17.4646 22.3 11.5 22.3C5.53528 22.3 0.699951 17.4646 0.699951 11.5C0.699951 5.53528 5.53528 0.699951 11.5 0.699951C17.4646 0.699951 22.3 5.53528 22.3 11.5ZM12.85 16.9C12.85 17.6455 12.2455 18.25 11.5 18.25C10.7544 18.25 10.15 17.6455 10.15 16.9C10.15 16.1544 10.7544 15.55 11.5 15.55C12.2455 15.55 12.85 16.1544 12.85 16.9ZM11.5 4.74995C10.7544 4.74995 10.15 5.35437 10.15 6.09995V11.5C10.15 12.2455 10.7544 12.85 11.5 12.85C12.2455 12.85 12.85 12.2455 12.85 11.5V6.09995C12.85 5.35437 12.2455 4.74995 11.5 4.74995Z"
            fill="#FF9892"
          />
        </svg>
      );
      break;
    case "question":
      return (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M22.2999 11.5C22.2999 17.4646 17.4646 22.3 11.5 22.3C5.53528 22.3 0.699951 17.4646 0.699951 11.5C0.699951 5.53528 5.53528 0.699951 11.5 0.699951C17.4646 0.699951 22.2999 5.53528 22.2999 11.5ZM11.5 7.44995C11.002 7.44995 10.5652 7.71889 10.3297 8.12593C9.95642 8.77131 9.13058 8.99185 8.4852 8.61852C7.83982 8.24519 7.61928 7.41935 7.99261 6.77397C8.69084 5.56695 9.9992 4.74995 11.5 4.74995C13.7367 4.74995 15.55 6.5632 15.55 8.79995C15.55 10.5633 14.423 12.0635 12.85 12.6195V12.85C12.85 13.5955 12.2456 14.2 11.5 14.2C10.7544 14.2 10.15 13.5955 10.15 12.85V11.5C10.15 10.7544 10.7544 10.15 11.5 10.15C12.2456 10.15 12.85 9.54554 12.85 8.79995C12.85 8.05437 12.2456 7.44995 11.5 7.44995ZM11.5 18.25C12.2455 18.25 12.85 17.6455 12.85 16.9C12.85 16.1544 12.2455 15.55 11.5 15.55C10.7544 15.55 10.15 16.1544 10.15 16.9C10.15 17.6455 10.7544 18.25 11.5 18.25Z"
            fill="#74ABB1"
          />
        </svg>
      );
      break;
    case "cell_yellow":
      return (
        <svg
          width="30"
          height="20"
          viewBox="0 0 30 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 7H28.5M1.5 13H28.5M15 7V19M4.5 19H25.5C27.1569 19 28.5 17.6569 28.5 16V4C28.5 2.34315 27.1569 1 25.5 1H4.5C2.84315 1 1.5 2.34315 1.5 4V16C1.5 17.6569 2.84315 19 4.5 19Z"
            stroke="#FBBF24"
            strokeWidth="2"
          />
        </svg>
      );
      break;
    case "cell_gray":
      return (
        <svg
          width="30"
          height="20"
          viewBox="0 0 30 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 7H28.5M1.5 13H28.5M15 7V19M4.5 19H25.5C27.1569 19 28.5 17.6569 28.5 16V4C28.5 2.34315 27.1569 1 25.5 1H4.5C2.84315 1 1.5 2.34315 1.5 4V16C1.5 17.6569 2.84315 19 4.5 19Z"
            stroke="#333333"
            strokeWidth="2"
          />
        </svg>
      );
      break;
    case "attachment":
      return (
        <svg
          width="19"
          height="20"
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.1716 5L5.58579 11.5858C4.80474 12.3668 4.80474 13.6332 5.58579 14.4142C6.36684 15.1953 7.63317 15.1953 8.41421 14.4142L14.8284 7.82843C16.3905 6.26633 16.3905 3.73367 14.8284 2.17157C13.2663 0.609476 10.7337 0.609476 9.17157 2.17157L2.75736 8.75736C0.414214 11.1005 0.414214 14.8995 2.75736 17.2426C5.1005 19.5858 8.89949 19.5858 11.2426 17.2426L17.5 11"
            stroke="#9DA3AE"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case "note":
      return (
        <svg
          width="20"
          height="17"
          viewBox="0 0 20 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 2.25278V15.2528M10 2.25278C8.83211 1.47686 7.24649 1 5.5 1C3.75351 1 2.16789 1.47686 1 2.25278V15.2528C2.16789 14.4769 3.75351 14 5.5 14C7.24649 14 8.83211 14.4769 10 15.2528M10 2.25278C11.1679 1.47686 12.7535 1 14.5 1C16.2465 1 17.8321 1.47686 19 2.25278V15.2528C17.8321 14.4769 16.2465 14 14.5 14C12.7535 14 11.1679 14.4769 10 15.2528"
            stroke="#333333"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case "observation":
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8409 25.7561L16.7562 26.159"
            stroke="#FB0707"
            strokeWidth="6"
            strokeLinecap="square"
            strokeLinejoin="bevel"
          />
          <path
            d="M12 21L20 24"
            stroke="#393939"
            strokeWidth="2"
            strokeLinejoin="bevel"
          />
          <path
            d="M13 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V27C20 27.5304 19.7893 28.0391 19.4142 28.4142C19.0391 28.7893 18.5304 29 18 29H14C13.4696 29 12.9609 28.7893 12.5858 28.4142C12.2107 28.0391 12 27.5304 12 27V5C12 4.73478 12.1054 4.48043 12.2929 4.29289C12.4804 4.10536 12.7348 4 13 4V4Z"
            stroke="#393939"
            strokeWidth="2"
            strokeLinejoin="bevel"
          />
          <path
            d="M16 8H20"
            stroke="#393939"
            strokeWidth="2"
            strokeLinejoin="bevel"
          />
          <path
            d="M16 12H20"
            stroke="#393939"
            strokeWidth="2"
            strokeLinejoin="bevel"
          />
          <path
            d="M16 16H20"
            stroke="#393939"
            strokeWidth="2"
            strokeLinejoin="bevel"
          />
          <path
            d="M16 20H20"
            stroke="#393939"
            strokeWidth="2"
            strokeLinejoin="bevel"
          />
          <path
            d="M9 4H23"
            stroke="#393939"
            strokeWidth="2"
            strokeLinejoin="bevel"
          />
        </svg>
      );
      break;
    case "test_icon":
      return (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M7.50842 0.699951C6.96239 0.699951 6.47014 1.02887 6.26118 1.53333C6.05223 2.03779 6.16773 2.61845 6.55382 3.00455L7.50842 3.95914V9.03157C7.50842 9.38962 7.36619 9.73299 7.11301 9.98617L1.71301 15.3862C-0.838342 17.9375 0.968628 22.2999 4.57679 22.2999H18.54C22.1482 22.2999 23.9552 17.9375 21.4038 15.3862L16.0038 9.98617C15.7507 9.73299 15.6084 9.38962 15.6084 9.03157V3.95914L16.563 3.00455C16.9491 2.61845 17.0646 2.03779 16.8557 1.53333C16.6467 1.02887 16.1544 0.699951 15.6084 0.699951H7.50842ZM10.2084 9.03157V3.39995H12.9084V9.03157C12.9084 10.1057 13.3351 11.1358 14.0946 11.8954L15.4818 13.2826C14.5141 13.0574 13.4995 13.103 12.5507 13.4192L11.916 13.6308C10.8075 14.0003 9.60916 14.0003 8.50072 13.6308L7.74141 13.3777C7.69 13.3606 7.63831 13.3451 7.58641 13.3311L9.0222 11.8954C9.78172 11.1358 10.2084 10.1057 10.2084 9.03157Z"
            fill="white"
          />
        </svg>
      );
      break;
    case "acknowledged":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 10.0001L9 12.0001L13 8.00012M5.83474 2.69717C6.55227 2.63991 7.23346 2.35775 7.78132 1.89087C9.0598 0.801351 10.9402 0.801351 12.2187 1.89087C12.7665 2.35775 13.4477 2.63991 14.1653 2.69717C15.8397 2.83079 17.1693 4.16043 17.303 5.83486C17.3602 6.55239 17.6424 7.23358 18.1093 7.78144C19.1988 9.05993 19.1988 10.9403 18.1093 12.2188C17.6424 12.7667 17.3602 13.4479 17.303 14.1654C17.1693 15.8398 15.8397 17.1695 14.1653 17.3031C13.4477 17.3603 12.7665 17.6425 12.2187 18.1094C10.9402 19.1989 9.0598 19.1989 7.78132 18.1094C7.23346 17.6425 6.55227 17.3603 5.83474 17.3031C4.16031 17.1695 2.83067 15.8398 2.69705 14.1654C2.63979 13.4478 2.35763 12.7667 1.89075 12.2188C0.801229 10.9403 0.801229 9.05993 1.89075 7.78144C2.35763 7.23358 2.63979 6.55239 2.69705 5.83486C2.83067 4.16043 4.16031 2.83079 5.83474 2.69717Z"
            stroke="#648D40"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case "notification":
      return (
        <svg
          width="17"
          height="20"
          viewBox="0 0 17 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0788 11.718L14.7344 11.4409C14.6418 11.3668 14.5671 11.2729 14.5157 11.166C14.4643 11.0591 14.4376 10.942 14.4375 10.8234V7.62511C14.437 6.25065 13.9598 4.91892 13.087 3.85707C12.2143 2.79523 11.0002 2.06905 9.65189 1.8024C9.58614 1.54741 9.4375 1.3215 9.22935 1.1602C9.02119 0.998908 8.76532 0.911377 8.50199 0.911377C8.23865 0.911377 7.98279 0.998908 7.77463 1.1602C7.56648 1.3215 7.41784 1.54741 7.35209 1.8024C6.00301 2.06824 4.78802 2.79407 3.91451 3.85599C3.04101 4.91792 2.56315 6.25009 2.56251 7.62511V10.8234C2.56244 10.942 2.53572 11.0591 2.48434 11.166C2.43295 11.2729 2.35821 11.3668 2.26564 11.4409L1.92126 11.718C1.50535 12.0505 1.16927 12.472 0.937733 12.9516C0.706197 13.4311 0.585098 13.9564 0.583344 14.4889V15.1459C0.583344 15.5659 0.750158 15.9686 1.04709 16.2655C1.34402 16.5625 1.74675 16.7293 2.16668 16.7293H5.43626C5.6147 17.4052 6.01181 18.0031 6.56565 18.4297C7.11949 18.8563 7.79894 19.0877 8.49803 19.0877C9.19712 19.0877 9.87657 18.8563 10.4304 18.4297C10.9843 18.0031 11.3814 17.4052 11.5598 16.7293H14.8333C15.2533 16.7293 15.656 16.5625 15.9529 16.2655C16.2499 15.9686 16.4167 15.5659 16.4167 15.1459V14.4968C16.4161 13.963 16.2956 13.4361 16.064 12.9551C15.8324 12.4741 15.4957 12.0514 15.0788 11.718ZM8.50001 17.5209C8.2237 17.5193 7.95263 17.4453 7.71375 17.3064C7.47487 17.1676 7.2765 16.9686 7.13834 16.7293H9.86563C9.72714 16.9692 9.52814 17.1685 9.28851 17.3074C9.04888 17.4463 8.777 17.52 8.50001 17.5209ZM14.8333 15.1459H2.16668V14.4968C2.1671 14.2001 2.2342 13.9074 2.36301 13.6402C2.49182 13.373 2.67904 13.1381 2.91084 12.953L3.25522 12.6759C3.53294 12.4536 3.75716 12.1717 3.91132 11.851C4.06547 11.5304 4.14562 11.1792 4.14584 10.8234V7.62511C4.14584 6.47032 4.60458 5.36282 5.42115 4.54625C6.23771 3.72969 7.34521 3.27095 8.50001 3.27095C9.65481 3.27095 10.7623 3.72969 11.5789 4.54625C12.3954 5.36282 12.8542 6.47032 12.8542 7.62511V10.8234C12.8538 11.1799 12.9337 11.5318 13.0878 11.8532C13.242 12.1746 13.4666 12.4571 13.7448 12.6799L14.0892 12.957C14.3205 13.1417 14.5074 13.3759 14.6362 13.6424C14.7649 13.9088 14.8323 14.2008 14.8333 14.4968V15.1459Z"
            fill="#648D40"
          />
        </svg>
      );
      break;
    case "tick":
      return (
        <svg
          width="19"
          height="14"
          viewBox="0 0 19 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${sizeCss} ${className}`}
        >
          <path
            d="M1 8.2L5.85714 13L18 1"
            stroke="#648D40"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case "tick_small":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={`${sizeCss} ${className}`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 12.75l6 6 9-13.5"
          />
        </svg>
      );
      break;
    case "share":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${sizeCss} ${className}`}
          stroke="currentColor"
        >
          <path
            d="M6.68387 11.3419C6.88616 10.9381 7 10.4824 7 10C7 9.51763 6.88616 9.06185 6.68387 8.65807M6.68387 11.3419C6.19134 12.3251 5.17449 13 4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.17449 7 6.19134 7.67492 6.68387 8.65807M6.68387 11.3419L13.3161 14.6581M6.68387 8.65807L13.3161 5.34193M13.3161 5.34193C13.8087 6.32508 14.8255 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4C13 4.48237 13.1138 4.93815 13.3161 5.34193ZM13.3161 14.6581C13.1138 15.0619 13 15.5176 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.8255 13 13.8087 13.6749 13.3161 14.6581Z"
            stroke="#648D40"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case "share_green":
      return (
        <svg
          width="24"
          height="20"
          viewBox="0 0 24 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${sizeCss} ${className}`}
          stroke="currentColor"
        >
          <path
            d="M6.68387 11.3428C6.88616 10.939 7 10.4832 7 10.0008C7 9.51847 6.88616 9.06269 6.68387 8.65891M6.68387 11.3428C6.19134 12.3259 5.17449 13.0008 4 13.0008C2.34315 13.0008 1 11.6577 1 10.0008C1 8.34399 2.34315 7.00084 4 7.00084C5.17449 7.00084 6.19134 7.67576 6.68387 8.65891M6.68387 11.3428L12.5 14M6.68387 8.65891L13 5.5"
            stroke={color ? color : "#648D40"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 5C21 7.20914 19.2091 9 17 9C14.7909 9 13 7.20914 13 5C13 2.79086 14.7909 1 17 1C19.2091 1 21 2.79086 21 5Z"
            stroke={color ? color : "#648D40"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 12C13.6863 12 11 14.6863 11 18V19H23V18C23 14.6863 20.3137 12 17 12Z"
            stroke={color ? color : "#648D40"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case "up_arrow_red":
      return (
        <svg
          width="9"
          height="16"
          viewBox="0 0 9 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.66663 4.45833L4.49996 1.625M4.49996 1.625L7.33329 4.45833M4.49996 1.625V14.375"
            stroke="#B60101"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case "down_arrow_red":
      return (
        <svg
          width="9"
          height="16"
          viewBox="0 0 9 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.33337 11.5417L4.50004 14.375M4.50004 14.375L1.66671 11.5417M4.50004 14.375L4.50004 1.625"
            stroke="#B60101"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;

    case "future_icon":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_11512_61212)">
            <path d="M10.5 8.25H9V16.5H10.5V8.25Z" fill="#DD0000" />
            <path d="M15 8.25H13.5V16.5H15V8.25Z" fill="#DD0000" />
            <path
              d="M12 1.5C13.3992 1.49959 14.7841 1.78051 16.0726 2.32607C17.361 2.87163 18.5266 3.67068 19.5 4.67573V1.5H21V7.5H15V6H18.6913C17.2861 4.43968 15.3789 3.42069 13.3007 3.11995C11.2226 2.8192 9.10476 3.25569 7.31488 4.35363C5.52501 5.45157 4.17612 7.14163 3.50241 9.13041C2.8287 11.1192 2.8727 13.2811 3.62678 15.2408C4.38085 17.2005 5.79739 18.8343 7.63045 19.8585C9.46352 20.8827 11.5974 21.2327 13.6616 20.8476C15.7257 20.4626 17.5899 19.3668 18.9304 17.7506C20.271 16.1344 21.0032 14.0998 21 12H22.5C22.5 14.0767 21.8842 16.1068 20.7304 17.8335C19.5767 19.5602 17.9368 20.906 16.0182 21.7007C14.0996 22.4955 11.9884 22.7034 9.95156 22.2982C7.91476 21.8931 6.04383 20.8931 4.57538 19.4246C3.10693 17.9562 2.1069 16.0852 1.70176 14.0484C1.29661 12.0116 1.50455 9.90045 2.29927 7.98182C3.09399 6.0632 4.4398 4.42332 6.16652 3.26957C7.89323 2.11581 9.9233 1.5 12 1.5Z"
              fill="#DD0000"
            />
          </g>
          <defs>
            <clipPath id="clip0_11512_61212">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
      break;
    default:
      return "";
  }
};
